export default __webpack_public_path__ + "static/media/fish&chips-Regular.74fc275e.otf";